import type { ReceiptTemplate } from '../schema';

export const tMobileTemplate: ReceiptTemplate = {
  id: 't-mobile',
  name: 'T-Mobile Receipt',
  brand: 'T-MOBILE',
  description: 'T-Mobile store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'tm-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/t-mobile.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: ['STORE #4892', '1200 DARK AVENUE', 'MONSTERVILLE, CA 94608'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'tm-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans #:', value: '847291034' },
          { id: 'rep', label: 'Rep:', value: 'MIKE W.' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'tm-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'SAMSUNG GALAXY S24 ULTRA', quantity: '1', price: '1199.99', sku: '' },
          { id: '2', name: 'DEVICE PROTECTION', quantity: '1', price: '18.00', sku: '' },
          { id: '3', name: 'SCREEN PROTECTOR', quantity: '1', price: '39.99', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'tm-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '1257.98', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '103.78', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '1361.76', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'tm-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'tm-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'T-MOBILE TUESDAYS\nDOWNLOAD THE APP\n\nTHANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

